import * as Yup from 'yup';

export const passwordResetValidationSchema = Yup.object().shape({
	email: Yup.string().email('not a valid email address').required('email address required'),
	membershipFieldValue: Yup.string().required('value required'),
	blockContentAbsoluteUri: Yup.string().required('Unexpected error')
});
